<template>
  <div class="slider-arrows">
    <button class="slider-arrows__item" title="Влево" type="button" @click="$emit('left')">
      <IconComponent name="arrow-left-s-line" />
    </button>
    <button class="slider-arrows__item" title="Вправо" type="button" @click="$emit('right')">
      <IconComponent name="arrow-right-s-line" />
    </button>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "SliderArrowsComponent",
  components: { IconComponent },
};
</script>

<style lang="stylus">

.slider-arrows {
  display: flex;
  z-index: 1;
  gap 10px

  +below(1024px) {
    display none
  }


  &__item {
    z-index: 1;
    background: var(--white);
    border: 1px solid var(--gray);
    border-radius 50px
    transition var(--transition)
    display flex
    justify-content center
    align-items center
    width: 40px;
    height: 40px;

    &:active {
      transform scale(0.98)
    }
  }

  .icon {
    display flex
    width 20px
    height: 20px;
    svg path {
      width 20px
      height: 20px;
      fill var(--black)
    }
  }

  button {
    cursor pointer
  }
}
</style>
